export enum Engagement {
  Favorited = 'Favorited',
  Scheduled = 'Scheduled',
  Started = 'Started',
  Completed = 'Completed',
}
